import React, {useEffect, useState} from 'react';
import {Button, Modal, Switch} from 'antd';
import {isLoading} from '../../store/TableRedux/TableRedux';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import Auth from "../../http_request/Model/auth/Auth";


const ConfirmSwitch = ({
                           rowData,
                           title = 'تغییر وضعیت',defStatus,
                           checkedChildren = 'فعال',
                           unCheckedChildren = 'غیر فعال',
                       }) => {
    const [checked, setChecked] = useState(defStatus);

    // const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setChecked(defStatus)
    }, [defStatus]);
    const handleShow = () => {

        setOpen(true);

    };


    const handleOk = () => {



        Auth.request({
            beforeSend: () => {
                dispatch(isLoading(true));
            }, success: (result) => {
                setChecked(!checked)
                setOpen(false)
                toast.success('تغییر وضعیت با موفقیت انجام شد.');
            }, error: (error) => {
                toast.error(error.data.message);
            }, final: () => {
                dispatch(isLoading(false));
            },
        }).changeStatus(rowData.userName,!checked);


    };


    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <>
            <Switch onClick={handleShow} checked={checked} unCheckedChildren={unCheckedChildren}
                    checkedChildren={checkedChildren}/>

            <Modal
                open={open}
                title={title}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                        انصراف
                    </Button>,
                    <Button className='defBtn blueBtn' key='submit' type='primary'  onClick={handleOk}>
                        ثبت
                    </Button>,

                ]}
            >
                <p>آیا از تغییر وضعیت اطمینان دارید؟</p>
            </Modal>
        </>

    );
};
export default ConfirmSwitch;